import React from 'react';
import { motion } from 'framer-motion';
import LockIcon from '@mui/icons-material/Lock';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
export function PricingCard() {
  return <section id="pricing" className="py-10 px-4 bg-slate-50 scroll-mt-12" data-id="element-170">
      <div className="max-w-4xl mx-auto text-center" data-id="element-171">
        <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-5" data-id="element-172">
          ELEGÍ TU PACK
        </h2>

        <motion.div id="pricing-card" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-md mx-auto bg-white rounded-3xl shadow-2xl border-4 border-brand-500 relative overflow-hidden scroll-mt-12" data-id="element-173">
          {/* Ribbon */}
          <div className="bg-yellow-400 text-yellow-900 font-bold py-2 text-center text-sm tracking-widest uppercase" data-id="element-174">
            ⭐ MÁS ELEGIDO
          </div>

          <div className="p-5" data-id="element-175">
            <h3 className="text-xl font-bold text-brand-800 mb-1" data-id="element-176">
              🐾 PACK EMPRENDEDOR
            </h3>
            <p className="text-slate-600 font-medium mb-2 text-sm" data-id="element-177">
              Tomo 1 + Tomo 2 + 4 Bonos
            </p>

            <p className="text-xs text-slate-500 mb-3 px-4" data-id="element-178">
              Ideal para empezar desde casa y generar ingresos extra.
            </p>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-179">
              <span className="text-slate-400 line-through text-xl font-bold" data-id="element-180">
                $49.999
              </span>
              <div className="flex items-start text-brand-700" data-id="element-181">
                <span className="text-2xl font-bold mt-2" data-id="element-182">$</span>
                <span className="text-5xl font-extrabold tracking-tight" data-id="element-183">
                  19.999
                </span>
                <span className="text-lg font-bold mt-2 ml-1" data-id="element-184">ARS</span>
              </div>
            </div>

            <button className="w-full bg-brand-600 hover:bg-brand-700 text-white text-lg font-bold py-3.5 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 mb-3" data-id="element-185">
              🐾 QUIERO EL PACK EMPRENDEDOR
            </button>

            <div className="flex flex-row flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-600 font-medium bg-slate-50 p-2.5 rounded-xl" data-id="element-186">
              <div className="flex items-center justify-center gap-2" data-id="element-187">
                <LockIcon fontSize="small" className="text-green-600" data-id="element-188" /> Pago
                seguro
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-189">
                <FlashOnIcon fontSize="small" className="text-yellow-600" data-id="element-190" />{' '}
                Acceso inmediato
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-191">
                <VerifiedUserIcon fontSize="small" className="text-blue-600" data-id="element-192" />{' '}
                Garantía 7 días
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}